export const NoteMessage = ({ note }: { note?: string }) => {
    if (!note) return null;

    return <div className="py-2 text-xs text-[#424242]">{note}</div>;
};
